import isEmpty from 'lodash/fp/isEmpty';
import omitBy from 'lodash/fp/omitBy';

export const toNullableValue = (value: string | null | undefined) => (value === '' || value === undefined ? null : value);

export const buildEditDataToSend = (
   subItemWithParts: Record<string, unknown>,
   rawThreeDModelNo: string | null | undefined,
   rawComment: string | null | undefined,
   rawRecycledContent: string | null | undefined,
   rawRenewableContent: string | null | undefined
) => ({
   ...omitBy((val) => (typeof val !== 'boolean' && typeof val !== 'number' ? isEmpty(val) : false))(subItemWithParts),
   threeDModelNo: rawThreeDModelNo ?? '',
   comment: rawComment ?? '',
   recycledContent: toNullableValue(rawRecycledContent),
   renewableContent: toNullableValue(rawRenewableContent),
});
